<template>
  <a-modal
    :visible="visible"
    okText="开始添加"
    :width="600"
    @ok="handleCreate"
    cancellText="取消"
    @cancel="visible = false"
    title="批量添加僵尸粉"
  >
    <a-alert
      :style="{ marginBottom: '15px' }"
      message="每次操作建议不要超过总好友数量的15%,误操作引起的账号问题，与平台无关"
    ></a-alert>
    <a-form :form="form" :labelCol="labelCol" :wrapperCol="wrapperCol">
      <a-form-item label="添加好友时间间隔" :wrapperCol="wrapperCol">
        <a-input-number
          :min="0"
          :formatter="value => `${value}秒`"
          v-decorator="['min_time', { initialValue: 15, rules: [{ required: true, message: '必填项' }] }]"
        >
        </a-input-number>
        -
        <a-input-number
          :min="0"
          :formatter="value => `${value}秒`"
          v-decorator="['max_time', { initialValue: 30, rules: [{ required: true, message: '必填项' }] }]"
        >
        </a-input-number>
      </a-form-item>
      <a-form-item label="本次添加人数">
        <a-input-number
          :min="0"
          v-decorator="[
            'num',
            {
              initialValue: this.wxids.length > 1 ? this.wxids.length : 1,
              rules: [{ required: true, message: '必填项' }],
            },
          ]"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import FansApi from '@/api/fans'
import { mapActions, mapGetters } from 'vuex'
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      visible: false,
      currentRobotId: 0,
      labelCol: {
        span: 8,
      },
      wrapperCol: {
        span: 12,
      },
      badge: ['[昵称]'],
      wxids: [], // 本次添加人数
      tableData: this.loadData,
    }
  },
  watch: {
    wxids(newVal, oldVal) {
      this.wxids = newVal
      // console.log('watch****wxids=', this.wxids)
      this.form.setFieldsValue({
        num: this.wxids.length,
      })
    },
    loadData: {
      deep: true,
      handler(newVal, oldVal){
        // console.log('***',newVal,oldVal)
        this.tableData = newVal
      }
    }
  },
  props: {
    loadData: {
      type: Array,
      default: [],
    },
  },
  methods: {
    ...mapActions(['WEBSOCKER_ACTIONS_SENDROBOTMSG']),
    show({ robotid, wxids }) {
      this.visible = true
      this.robotid = robotid
      this.wxids = wxids
    },
    handleCreate() {
      this.form.validateFields((err, values) => {
        // 过滤掉状态为5和6的wxid
        this.tableData = this.tableData.filter(item => {
          return item.del !== '5' && item.del !== '6'
        })
        if(this.tableData.length==0){
          this.$message.success('所有僵尸粉均已添加')
          this.visible = false
          return
        }
        let wxid = this.wxids.join(',')

        // console.log('this.tableData=', this.tableData)
        // console.log('wxid=',wxid=='')
        // if (values.num == 1) {
        //   this.wxids.push(this.tableData[0].wxid)
        // }
        // console.log('this.wxids=', this.wxids)

        let parameter = {
          sub_id: this.robotid,
          num: values.num,
          wxid: this.wxids.join(','),
        }
        // console.log('给接口的参数=', parameter)

        if (this.wxids.length <= 0) {
          this.$message.error('请勾选您要添加的僵尸粉')
        } else {
          FansApi.addInactive(parameter)

          const data = {
            // wxid_list: this.wxids, // 批量添加-不需要传wxid
            max_time: values.max_time,
            min_time: values.min_time,
            num: this.wxids.length,
            type: 1,
          }
          // 向机器人发送消息
          this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
            robotid: this.robotid,
            type: 'die_fans_add',
            data: data,
          }).then(result => {
            this.$message.success('发送指令成功')
            this.visible = false
          })
        }
      })
      // this.form.resetFields()
    },
  },
}
</script>